import { useEffect } from "react";

/**
 * Locks page scrolling while `isLocked` is true.
 *
 * Freezes `html` - the document's actual scrolling element - in place,
 * rather than `body`. Locking via `body.style.overflow` turns body into a
 * scroll container of its own, which cancels `position: sticky` for
 * elements like the header (they end up pinned to body's frozen scrollTop
 * of 0 instead of the viewport) and causes a jump back to the top; on
 * unlock, restoring body can also leave the page at the wrong scroll
 * position. Freezing html instead never touches its scrollTop, so nothing
 * moves on lock or unlock.
 */
export const useScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (!isLocked) {
      return undefined;
    }

    const { documentElement } = document;
    const { overflow } = documentElement.style;
    documentElement.style.overflow = "hidden";

    return () => {
      documentElement.style.overflow = overflow;
    };
  }, [isLocked]);
};

export default useScrollLock;
